var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.733 14.2v6.129A2.671 2.671 0 0 1 10.062 23h-6.39A2.672 2.672 0 0 1 1 20.329V5.139a2.673 2.673 0 0 1 2.672-2.672h2.461M1 18.6h11.733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.067 1H12a2.933 2.933 0 0 0-2.933 2.933v4.4A2.933 2.933 0 0 0 12 11.267h3.667v3.666l3.666-3.666h.734A2.933 2.933 0 0 0 23 8.333v-4.4A2.933 2.933 0 0 0 20.067 1zm-7.7 4.767h0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.367 5.767a.367.367 0 1 0 0 .733.367.367 0 0 0 0-.733m3.666 0h0m0 0a.367.367 0 1 0 0 .733.367.367 0 0 0 0-.733m3.667 0h0m0 0a.367.367 0 1 0 0 .733.367.367 0 0 0 0-.733"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.e4a08a4f.svg";
export { ForwardRef as ReactComponent };